import React from "react";
import { Navigation, Link } from "react-router";
import {sidebarOnClicks, scrollTo, mountCode, initDeepLinkData} from "js/utilities/sdk-doc-utils";
import FontAwesome from "react-fontawesome";
import UserHandler from "js/utilities/user-handler";
import SDKSidebar from "js/utilities/sdk-sidebar"
import Zoom from "js/utilities/zoom-handler"
import Amplitude from "js/utilities/amplitude";

export default React.createClass({
  mixins: [Navigation],

  displayName: "Developer Info",

  contextTypes: {
    router: React.PropTypes.object.isRequired
  },

  scrollToGuide : null,
  scrollingEl: null,
  getInitialState: function() {
    var data  = [{name: "docs-info"},
                 {name: "Step 1"},
                 {name: "Step 2"},
                 {name: "Step 3"},
                 {name: "Step 4"},
                 {name: "Step 5"},
                 {name: "Customizing Features"},
                 {name: "Exploring Functionality"},
                 {name: "Further Assistance"}
        ];

    var scrollToElement = initDeepLinkData(this.props);

    return {
      data,
      navMenuParent: null,
      navMenu: null,
      scrollToElement: scrollToElement
    };
  },

  getInitialState() {
    var data  = [{name: "docs-info"},
                 {name: "Get Started"},
                 {name: "Get Up And Running"},
                 {name: "Step 1"},
                 {name: "Step 2"},
                 {name: "Step 3"},
                 {name: "Step 4"},
                 {name: "Step 5"},
                 {name: "Customizing Features"},
                 {name: "Exploring Functionality"},
                 {name: "Further Assistance"}
        ];

    var scrollToElement = initDeepLinkData(this.props);

    return {
      data,
      androidDownloading: false,
      iosDownloadingSwift: false,
      iosDownloadingObj: false,
      scrollToElement: scrollToElement
    };
  },

  componentDidMount: function() {
    mountCode(this);
    sidebarOnClicks();
  },

  componentWillMount() {
    Zoom.getVersion(this);
  },

  downloadPackage : function(platformString, platformExtension) {
    if (!platformExtension)
      platformExtension = ""
    Zoom.download(platformString).then (() => {
      _.delay(
        function delay() {
          this.setState({androidDownloading : false, iosDownloadingSwift: false, iosDownloadingObjC: false});
          Amplitude.send("download-"+platformString+platformExtension);
        }.bind(this),750);
    }).catch((error) => {
      this.context.router.push("/signin");
    })
  },

  _androidDownload : function() {
    this.setState({androidDownloading : true});
    this.downloadPackage("android")
  },

  _iosDownloadSwift : function() {
    this.setState({iosDownloadingSwift : true});
    this.downloadPackage("ios", "swift")
  },

  _iosDownloadObjC : function() {
    this.setState({iosDownloadingObjC : true});
    this.downloadPackage("ios", "objc")
  },

  _getSDKDocVersions : function(cb) {
    SDKDocVersions.get( function _getData(response) {
      return(cb(response));
    });
  },

  _releaseBuildDropBox: function () {
    if (!UserHandler.loggedIn()) {
      this.context.router.push("/signin");
      return
    }
    window.open(
      "https://www.dropbox.com/sh/rfwohmof1ddd65t/AABFJ3Hpf3NkI3caBwNS7B4Va?dl=0", "_blank");
  },

  render: function() {

    if (this.scrollToGuide && this.scrollingEl)
      scrollTo(this.scrollingEl, this.scrollToGuide);
    this.scrollToGuide = null;

    var loggedInShow = {}
    if (UserHandler.loggedIn() == "") {
      loggedInShow["display"] = "none"
    }

    var zoomWebUrl = "https://browser.zoomlogin.com/"
    var ageCheckUrl = "https://agecheck.zoomlogin.com/"

    return (
      <div className="dash">
        <div className="workspace">
          <div className="workspace__container">
            <section>
              <div className="title">
                <h2 style={{fontSize: "22px", lineHeight: "30px"}}>
                Welcome to your FaceTec Developer Account
                </h2>
                <p>The 7 steps below are required to add FaceTec to your App, just stick to these steps and you'll be authenticating in no time!</p>
              </div>
            </section>

            <hr />

            <section>
              <p><strong>Step 1</strong> - Do you know what FaceTec is and what it does?  If not, check out <a href="https://facetec.com" target="_blank">www.FaceTec.com</a> & <a href="https://liveness.com" target="_blank">www.Liveness.com</a>.</p>

              <p><strong>Step 2</strong> - Have you used FaceTec before?  If not, please try the Demo Apps here: <a href={zoomWebUrl} target="_blank">Browser</a>,&nbsp;
                      <a href="https://apps.apple.com/us/app/zoom-id-check/id1465840596" target="_blank">iOS</a>,&nbsp;
                      <a href="https://play.google.com/store/apps/details?id=com.facetec.zoomlogin&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1" target="_blank">
                      Android
                      </a> & <a href={ageCheckUrl} target="_blank">Age Check</a>.
                      Then see your Sessions in the <Link to="/server-dashboard-demo">FaceTec Server Dashboard</Link>.</p>

              <p><strong>Step 3</strong> - Do you have Technical Questions about <Link to="/ui-customization">UI Customization</Link>, <Link to="/zoom-configuration-options">Configurations</Link>, <Link to="/compatibility">Compatibility</Link>, <Link to="/technical-specs">Architecture or Hardware Specs</Link>?</p>

              <p><strong>Step 4</strong> - Ready to integrate the FaceTec Device SDKs into your Apps and do some testing??   <Link to="/getting-started">Get Started Here</Link>.</p>

              <p><strong>Step 5</strong> - Wondering how much FaceTec costs??  <Link to="/quote">Get a Quote Here</Link>.</p>

              <p><strong>Step 6</strong> - Want the FaceTec Server SDK??  That will require a commercial discussion, request a <Link to="/quote">Sales Call Here</Link>.</p>

              <p><strong>Step 7</strong> - Ready to go into Production?  If you've signed your Customer Agreement, please read the <Link to="/going-production-overview">Going Production Overview Guide</Link>, Download your <Link to="/downloads">Server SDK Here</Link>, & <Link to="/account">SDK Keys Here</Link>.</p>

              <hr/>

              <p>Got Questions?  Try our <Link to="/faq">FAQ's</Link>, our <Link to="/technical-support">Technical Support Page</Link>, or Search for specific terms using the box in the upper left.</p>

              <hr />

              <p>Need Non-Technical Info?  Try <a target="_new" href="https://facetec.com">www.FaceTec.com</a>, <a target="_new" href="https://liveness.com">Liveness.com</a>, or <Link to="/quote">Get A Pricing Quote</Link>.</p>

              <hr />

              <p>Think You Can Spoof FaceTec?  Try our <Link to="/spoof-bounty-program">$100,000 Spoof Bounty Program</Link>, and get more info at <a target="_new" href="https://spoofbounty.com">SpoofBounty.com</a>.</p>

            </section>

            <SDKSidebar menuType="main" title="Developer"/>

          </div>
        </div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/docs.jsx